import statusFormatter from 'utils/statusFormatter'
import { PROFILE_STATUS } from 'constants/myProfile'
import { actionButtonText } from './constants'

export const isProfileAccessIndeterminate = profileStatus => {
  const formattedStatus = statusFormatter(profileStatus)
  if (
    formattedStatus === PROFILE_STATUS.CHECK_OUT_SUBMITTED ||
    formattedStatus === PROFILE_STATUS.CHECK_IN_SUBMITTED
  ) {
    return true
  }

  return false
}

export const isApprovalNeeded = profileStatus => {
  const formattedStatus = statusFormatter(profileStatus)
  if (
    formattedStatus === PROFILE_STATUS.APPROVAL_REQUIRED ||
    formattedStatus === PROFILE_STATUS.APPROVAL_PENDING
  ) {
    return true
  }

  return false
}

export const shouldDisableProfileAccess = profileStatus => {
  if (statusFormatter(profileStatus) === PROFILE_STATUS.CHECKED_OUT) {
    return false
  }

  return true
}

export const getActionButtonText = profileStatus => {
  const formattedStatus = statusFormatter(profileStatus)

  if (
    formattedStatus === PROFILE_STATUS.AVAILABLE ||
    formattedStatus === PROFILE_STATUS.CHECK_OUT_SUBMITTED ||
    formattedStatus === PROFILE_STATUS.CHECK_OUT_FAILED ||
    formattedStatus === PROFILE_STATUS.CHECK_OUT_TIMED_OUT
  ) {
    return actionButtonText.CHECKOUT
  }

  if (formattedStatus === PROFILE_STATUS.APPROVAL_REQUIRED) {
    return actionButtonText.REQUEST
  }

  if (formattedStatus === PROFILE_STATUS.APPROVAL_PENDING) {
    return actionButtonText.WITHDRAW
  }

  return actionButtonText.CHECKIN
}

export const getButtonVariant = buttonLabel => {
  if (
    buttonLabel === actionButtonText.CHECKOUT ||
    buttonLabel === actionButtonText.REQUEST
  ) {
    return 'primary'
  }

  return 'secondary'
}

export const getCredentialsAsString = credsData => {
  if (typeof credsData === 'string') {
    return credsData
  }

  return JSON.stringify(credsData)
}

export const getProfileData = (
  allProfiles = [],
  selectedProfileId,
  selectedResourceId
) => {
  return allProfiles.find(
    profile =>
      profile.profileId === selectedProfileId &&
      profile.resourceId === selectedResourceId
  )
}
